import { vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { CalendarDots } from '@phosphor-icons/react';
import type { DEPARTURE_DATE, RETURN_DATE } from '../constants/formFields';

const calendarButtonStyles = css`
  align-items: center;
  background: none;
  border: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  transition: background 0.2s ease-in-out;
  width: 2.75rem;

  [dir='rtl'] & {
    left: 0;
    right: initial;
  }

  &:focus-visible {
    outline: 2px solid ${vars.colors.focusRing};
  }
`;

const iconStyles = css`
  height: 1.25rem;
  width: 1.25rem;
`;

const calendarButtonExpandedStyles = css`
  & > svg {
    background: ${vars.colors.inputs.selected};
  }
`;

export interface CalendarButtonProps {
  'aria-controls': string;
  'aria-expanded': boolean;
  'aria-label'?: string;
  boundIndex: number;
  fieldName: typeof DEPARTURE_DATE | typeof RETURN_DATE;
  onClick: (fieldName: typeof DEPARTURE_DATE | typeof RETURN_DATE) => void;
}

const CalendarButton = ({
  'aria-controls': ariaControls,
  'aria-expanded': ariaExpanded,
  'aria-label': ariaLabel,
  boundIndex,
  fieldName,
  onClick,
}: CalendarButtonProps) => {
  const handleOnClick = () => {
    onClick(fieldName);
  };

  return (
    <button
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      aria-label={ariaLabel}
      className={cx(calendarButtonStyles, ariaExpanded ? calendarButtonExpandedStyles : undefined)}
      data-testid={`calendar-${fieldName}`}
      id={`calendar-icon-${fieldName}-${boundIndex}`}
      onClick={handleOnClick}
      type="button"
    >
      <CalendarDots aria-hidden className={iconStyles} />
    </button>
  );
};

export default CalendarButton;
